
import * as api from "../../../../api"; 


  
export const createNewFolder = (folderAPIData) => async (dispatch)=>{
    try {
        const {data } = await api.createNewFolder(folderAPIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllFoldersByApp = (folderAPIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllFoldersByApp(folderAPIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const reArrangeFolders = (folderAPIData) => async (dispatch)=>{
  try {
      const {data } = await api.reArrangeFolders(folderAPIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}